<template>
  <font-awesome-icon
    icon="phone-alt"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faPhoneAlt)

export default {
  name: 'CoozzyPhoneAltIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey-dark;
  }
</style>
